import { values } from 'lodash';
import { AnalyticsService } from './../analytics/analytics.service';
import { AuthService, User } from './../user/auth.service';
import { RegistryFirebaseService } from './../registry/registry-firebase.service';
import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnInit,
  AfterViewInit,
  OnDestroy,
  HostListener,
  AfterViewChecked
} from '@angular/core';
import { SettingsService } from '../settings/settings.service';
import {
  FormGroup,
  FormArray,
  FormBuilder,
  Validators,
  FormControl,
  AbstractControl
} from '@angular/forms';
import { CustomValidatorsService } from '../shared/validators.service';
import { RegistryService } from '../registry/registry.service';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { PaymentService } from '../payment/payment.service';
import { Registry } from '../registry/registry';
import { Subject } from 'rxjs/Subject';
import { defineDirective } from '@angular/core/src/render3';
import { WriteTreeCompleteChildSource } from '@firebase/database/dist/esm/src/core/view/CompleteChildSource';
import { DatepickerOptions } from 'ng2-datepicker';
import * as en from 'date-fns/locale/en';
import { Website } from '../website-builder/wedding';
import { WebsiteStateStore } from '../website-builder/website.state.store';
import { UserService } from '../user/user.service';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-personal',
  templateUrl: './personal.component.html',
  styleUrls: ['./personal.component.scss'],
  providers: [SettingsService, CustomValidatorsService]
})
export class PersonalComponent implements OnInit, AfterViewInit, OnDestroy, AfterViewChecked {
  @Output() saved: EventEmitter<string> = new EventEmitter<string>();
  @Input() skipLoad: boolean;
  @Input() mode: string;
  public hitchdForm: FormGroup;
  buttonText = 'create';
  public submitted: boolean;
  noDate = true;
  days: Array<number>;
  user: User;
  emptyDate:Date;
  years: Array<number>;
  website: Website
  registryName: string;
  weddingDay: string;
  date: Date;
  regOriginalDate: Date;
  weddingMonth: string;
  hideRecommendedAmount= false;
  showRecommendedAmount= false;
  procesing: boolean;
  country: string;
  currency: string;
  registry: Registry;
  hasPaidGifts: boolean;
  hasStripeSetup = false;
  isWeddingRegistry: boolean;
  middleName: string;
  private ngUnsubscribe: Subject<void> = new Subject();
  options: DatepickerOptions = {
    minYear: 2018,
    maxYear: 2025,
    displayFormat: 'MMMM D YYYY',
    barTitleFormat: 'MMMM YYYY',
    dayNamesFormat: 'dd',
    firstCalendarDay: 0, // 0 - Sunday, 1 - Monday
    locale: en,
    barTitleIfEmpty: 'Click to select a date'
    // placeholder: 'Click to select a date', // HTML input placeholder attribute (default: '')
    // addClass: 'form-control', // Optional, value to pass on to [ngClass] on the input field
    // addStyle: {}, // Optional, value to pass to [ngStyle] on the input field
    // fieldId: 'my-date-picker', // ID to assign to the input field. Defaults to datepicker-<counter>
    // useEmptyBarTitle: false, // Defaults to true. If set to false then barTitleIfEmpty will be disregarded and a date will always be shown
  };
  currentPosition: number;
  fragment: string;
  hideMobileMenu: boolean;

  @HostListener('window:scroll', ['$event'])
  onWindowScroll(e: Event) {
   
    let scroll = window.pageYOffset || document.documentElement.scrollTop;

    if (scroll > this.currentPosition && (scroll > 2)) {
      this.hideMobileMenu = true;
    } else {
      this.hideMobileMenu = false;
    }

    this.currentPosition = scroll;
    
  }

  constructor(
    private _fb: FormBuilder,
    private _validatorService: CustomValidatorsService,
    private _authService: AuthService,
    private _registryService: RegistryService,
    private _route: ActivatedRoute,
    private _router: Router,
    private _paymentService: PaymentService,
    private _registryFirebaseService: RegistryFirebaseService,
    private _analyticsService: AnalyticsService,
    private _websiteStateStore: WebsiteStateStore,
    private _userService: UserService
  ) {

    window.scrollTo(0, 0);

    document.title = 'Account | Hitchd';
    this._route.fragment.subscribe(fragment => { this.fragment = fragment; });
  }
  openMobileMenu() {
    this._userService.emitUpdateHeaderType('showMobileMenu');
  }
  ngOnInit() {
    this._router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      const fragment = this._route.snapshot.fragment;
      if (fragment) {
        setTimeout(() => {
          this.scrollToElement(fragment);
        }, 500);
      }
    });

    this._authService.user.subscribe(user => {
      if (user) {
        this.user = user;
        this._registryFirebaseService
          .registryForUser(user).takeUntil(this.ngUnsubscribe)
          .subscribe(registry => {
            this.registry = registry;

            // this.setTitle();
            if (!this.skipLoad) {
              this.load();
              this.buttonText = 'Save';
            }

            this._registryFirebaseService.killLoader();
          });

        this._registryFirebaseService.getSettings().subscribe(setting => {

          if (setting) {

            this.hasStripeSetup = setting.stripeAccountId != null;
            if (this.hitchdForm && this.hasStripeSetup) {
              this.hitchdForm.controls['country'].disable();
              this.hitchdForm.controls['currency'].disable();
            }
          }
        });
      }

      this.website = this._route.snapshot.data.website;

    this._websiteStateStore.getState().subscribe(state => {

      if(state && state.website){
        this.website = state.website;
      }

    })
    ;
      this._route.fragment.subscribe(fragment => {
        if (fragment) {
          this.fragment = fragment;
          if (!this._router.navigated) {
            setTimeout(() => {
              this.scrollToElement(fragment);
            }, 500);
          }
        }
      });
    });

    this.populateDateDropDownValues();
    // this.registryName = this._registryService.getRegistryName();

    this.hitchdForm = this._fb.group({
      isWeddingRegistry: [''],
      isOtherRegistry: [''],
      profileImageUrl: ['', []],
      firstName: ['', []],
      partnerFirstName: ['', []],
      weddingDay: [],
      introductionText: [''],
      introTitle: [''],
      weddingMonth: [],
      weddingYear: [],
      hideIntroText: [],
      hideIntroTitle: [],
      hideHashtag: [''],
      hideRecommendedAmount: [''],
      showRecommendedAmount: [''],
      hashtag: [''],
      partnerEmail: [''],
      doNotUpSellGuestCards: [''],
      registryName: [
        '',
        [
          Validators.required,
          Validators.minLength(4),
          ,
          Validators.maxLength(65),
          Validators.pattern(/^[a-zA-Z0-9]*$/),
          this.checkDomainName.bind(this)
        ]
      ],
      currency: [{ value: '' }, [Validators.required]],
      country: [{ value: '' }, [Validators.required]],
      defaultGiftPrice: [],
      hasPassword: [''],
      password: ['']
    });
  }


  ngAfterViewChecked(): void {
    if (this.fragment) {
      setTimeout(() => {
        this.scrollToElement(this.fragment);
        this.fragment = null;  // Clear the fragment so we don't keep scrolling
      }, 500);
    }
  }
  scrollToElement(elementId: string): void {
    const element = document.getElementById(elementId);
    if (element) {
      element.scrollIntoView({ 
        behavior: 'smooth', 
        block: 'start'
      });

      if (elementId === 'site-url') {
        const inputElement = document.getElementById('site-url-text');
        if (inputElement) {
          setTimeout(() => {
            inputElement.focus();
          }, 600);
        }
      }
    }
  }
  datePicked() {
    if (this.date !== this.regOriginalDate) {
      this.hitchdForm.controls['weddingDay'].setValue(this.date.getDate());
      this.hitchdForm.controls['weddingMonth'].setValue(
        this.date.getMonth() + 1
      );
      this.hitchdForm.controls['weddingYear'].setValue(this.date.getFullYear());
      this.hitchdForm.markAsTouched();
    }
  }
  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
  updateCurrency() {
    this.country = this.hitchdForm.controls['country'].value;
    switch (this.hitchdForm.controls['currency'].value) {
      case 'AUD': {
        this.currency = 'AUD $';
        break;
      }
      case 'USD': {
        this.currency = 'USD $';
        break;
      }
      case 'GBP': {
        this.currency = 'GBP £';
        break;
      }
      case 'NZD': {
        this.currency = 'NZD $';
        break;
      }
      case 'MXN': {
        this.currency = 'MXN $';
        break;
      }
      case 'CHF': {
        this.currency = 'CHF';
        break;
      }

      case 'JPY': {
        this.currency = 'JPY ¥';
        break;
      }
      case 'EUR': {
        this.currency = 'EUR €';
        break;
      }
      case 'SGD': {
        this.currency = 'SGD $';
        break;
      }
      case 'HKD': {
        this.currency = 'HKD $';
        break;
      }
      case 'CAD': {
        this.currency = 'CAD $';
        break;
      }
      case 'DKK': {
        this.currency = 'DKK Kr';
        break;
      }
      case 'SEK': {
        this.currency = 'Kr';
        break;
      }
      case 'NOK': {
        this.currency = 'Kr';
        break;
      }
    }
  }

  setCurrency() {
    switch (this.country) {
      case 'AU': {
        this.hitchdForm.controls['currency'].setValue('AUD');
        break;
      }
      case 'MX': {
        this.hitchdForm.controls['currency'].setValue('MXN');
        break;
      }
      case 'US': {
        this.hitchdForm.controls['currency'].setValue('USD');
        break;
      }
      case 'GB': {
        this.hitchdForm.controls['currency'].setValue('GBP');
        break;
      }
      case 'DK': {
        this.hitchdForm.controls['currency'].setValue('DKK');
        break;
      }
      case 'NZ': {
        this.hitchdForm.controls['currency'].setValue('NZD');
        break;
      }

      case 'JP': {
        this.hitchdForm.controls['currency'].setValue('JPY');
        break;
      }

      case 'CA': {
        this.hitchdForm.controls['currency'].setValue('CAD');
        break;
      }
      case 'AT': {
        this.hitchdForm.controls['currency'].setValue('EUR');
        break;
      }
      case 'BE': {
        this.hitchdForm.controls['currency'].setValue('EUR');
        break;
      }
      case 'EE': {
        this.hitchdForm.controls['currency'].setValue('EUR');
        break;
      }
      case 'FI': {
        this.hitchdForm.controls['currency'].setValue('EUR');
        break;
      }
      case 'FR': {
        this.hitchdForm.controls['currency'].setValue('EUR');
        break;
      }
      case 'DE': {
        this.hitchdForm.controls['currency'].setValue('EUR');
        break;
      }
      case 'GR': {
        this.hitchdForm.controls['currency'].setValue('EUR');
        break;
      }
      case 'IE': {
        this.hitchdForm.controls['currency'].setValue('EUR');
        break;
      }
      case 'IT': {
        this.hitchdForm.controls['currency'].setValue('EUR');
        break;
      }
      case 'LV': {
        this.hitchdForm.controls['currency'].setValue('EUR');
        break;
      }
      case 'LT': {
        this.hitchdForm.controls['currency'].setValue('EUR');
        break;
      }
      case 'LU': {
        this.hitchdForm.controls['currency'].setValue('EUR');
        break;
      }
      case 'NL': {
        this.hitchdForm.controls['currency'].setValue('EUR');
        break;
      }
      case 'PT': {
        this.hitchdForm.controls['currency'].setValue('EUR');
        break;
      }
      case 'MX': {
        this.hitchdForm.controls['currency'].setValue('MXN');
        break;
      }
      case 'SK': {
        this.hitchdForm.controls['currency'].setValue('EUR');
        break;
      }
      case 'SI': {
        this.hitchdForm.controls['currency'].setValue('EUR');
        break;
      }
      case 'ES': {
        this.hitchdForm.controls['currency'].setValue('EUR');
        break;
      }
      case 'SG': {
        this.hitchdForm.controls['currency'].setValue('SGD');
        break;
      }
      case 'SG': {
        this.hitchdForm.controls['currency'].setValue('USD');
        break;
      }
      case 'HK': {
        this.hitchdForm.controls['currency'].setValue('HKD');
        break;
      }
      case 'SE': {
        this.hitchdForm.controls['currency'].setValue('SEK');
        break;
      }
      case 'NO': {
        this.hitchdForm.controls['currency'].setValue('NOK');
        break;
      }
      case 'CH': {
        this.hitchdForm.controls['currency'].setValue('CHF');
        break;
      }
      case 'JP': {
        this.hitchdForm.controls['currency'].setValue('EUR');
        break;
      }
    }
  }

  onCheckledIntroText(checked: boolean) {
    this.hitchdForm.controls['hideIntroText'].setValue(checked);
    this.registry.hideIntroText = checked;

    this.hitchdForm.markAsTouched();
    const textarea: HTMLTextAreaElement = <HTMLTextAreaElement>(
      document.getElementById('introtext')
    );
    //


  }

  onCheckledHasPassword(checked: boolean) {
    this.hitchdForm.controls['hasPassword'].setValue(checked);
    this.hitchdForm.markAsTouched();
    if (!checked) {
      this.registry.password = '';
      this.hitchdForm.controls['password'].setValue('');
    }
    this.registry.hasPassword = checked;
  }


  onCheckedHideTitle() {

    this.registry.hideIntroTitle = !this.registry.hideIntroTitle;
    if (this.hitchdForm.controls['hideIntroTitle']) {
      this.hitchdForm.controls['hideIntroTitle'].setValue(this.registry.hideIntroTitle);
    }
    this.hitchdForm.markAsTouched();

  }


  onCheckedHideHashTag() {

    this.registry.hideHashtag = !this.registry.hideHashtag;
    if (this.hitchdForm.controls['hideHashtag']) {
      this.hitchdForm.controls['hideHashtag'].setValue(this.registry.hideHashtag);
    }
    this.hitchdForm.markAsTouched();
  }
  onHideRecommendationChecked(checked: boolean) {
      this.hideRecommendedAmount = checked;

      this.hitchdForm.controls['hideRecommendedAmount'].setValue(checked);
      if (!checked){
          this.registry.defaultGiftPrice = 100;
      } else {
        this.registry.defaultGiftPrice = null;
      }
      this.hitchdForm.controls['defaultGiftPrice'].setValue(this.registry.defaultGiftPrice);
      this.hitchdForm.markAsTouched();
  }

  onShowRecommendationChecked(checked: boolean) {
    this.showRecommendedAmount = checked;
    this.hitchdForm.controls['showRecommendedAmount'].setValue(checked);
    if (checked){
        this.registry.defaultGiftPrice = 100;
    } else {
      this.registry.defaultGiftPrice = null;
    }
    this.hitchdForm.controls['defaultGiftPrice'].setValue(this.registry.defaultGiftPrice);
    this.hitchdForm.markAsTouched();
}

onDoNotUpSellGuestCardsChecked(checked: boolean) {
  
  this.hitchdForm.controls['doNotUpSellGuestCards'].setValue(checked);
  this.registry.doNotUpSellGuestCards = checked;
  //this.hitchdForm.controls['defaultGiftPrice'].setValue(this.registry.defaultGiftPrice);
  this.hitchdForm.markAsTouched();
}



  onCheckled(checked: boolean) {
    if (checked) {
      this.noDate = true;
      this.hitchdForm.controls['weddingDay'].clearValidators();
      this.hitchdForm.controls['weddingMonth'].clearValidators();
      this.hitchdForm.controls['weddingYear'].clearValidators();
      this.hitchdForm.controls['weddingDay'].setValue(null);
      this.hitchdForm.controls['weddingMonth'].setValue(null);
      this.hitchdForm.controls['weddingYear'].setValue(null);
    } else {
      this.noDate = false;
      this.date = new Date();

      this.hitchdForm.controls['weddingDay'].setValidators(Validators.required);
      this.hitchdForm.controls['weddingMonth'].setValidators(
        Validators.required
      );
      this.hitchdForm.controls['weddingYear'].setValidators(
        Validators.required
      );
      this.hitchdForm.controls['weddingDay'].setValue(null);
      this.hitchdForm.controls['weddingMonth'].setValue(null);
      this.hitchdForm.controls['weddingYear'].setValue(null);
      this.datePicked();
    }
    this.hitchdForm.markAsTouched();
  }

  checkDomainName(control: AbstractControl) {
    if (this.hitchdForm && control && control.value) {
      this.registryName = control.value.toLowerCase();
      if (
        this.registryName.toLowerCase() !==
        this.registry.registryName.toLowerCase()
      ) {
        //
        this._registryFirebaseService
          .registryByName(control.value)
          .take(1)
          .subscribe(registry => {
            //
            if (registry) {
              this.hitchdForm.controls['registryName'].setErrors({
                registryNotavailable: true
              });
            }
          });
      }
    }
  }

  removePhoto() {
    this.registry.profileImageUrl = null;

    this._registryFirebaseService.updateRegistryProfilePic(
      this.user,
      this.registry.id,
      null
    );
  }

  setTitle() {
    let title = '';

    if (this.registry.firstName && this.registry.partnerFirstName) {
      title = this.registry.firstName + ' and ' + this.registry.partnerFirstName + '\'s ';
    }

    if(this.registry.isOtherRegistry){
      title =  this.registry.firstName + ' and ' + this.registry.partnerFirstName + ' on Hitchd';
    } else if (this.registry.isWeddingRegistry) {
      title += 'Wedding Registry on Hitchd';
    } else {
      title += 'Honeymoon Registry on Hitchd';
    }
    document.title = title;
  }


  handledUploadedImage(event: any) {
    if (event) {
      event = event + '?hex=ffffff';
      this._registryFirebaseService
        .updateRegistryProfilePic(this.user, this.registry.id, event)
        .then(registry => {
          this.registry.profileImageUrl = event;

          if (registry) {
            // this.registry = registry;
          }
        });
    }
  }

  openUploader() {
    document.getElementById('file_input_id').click();
  }

  ngAfterViewInit(): void {
    if (this.hitchdForm) {
      const textarea: HTMLTextAreaElement = <HTMLTextAreaElement>(
        document.getElementById('introtext')
      );
      //
      if (textarea) {
        textarea.value = textarea.value + '';
        this.expandTextArea(textarea);
      }
    }
  }

  setIntroAsTouched() {
    this.hitchdForm.controls['introductionText'].markAsTouched();
  }

  expandTextArea(textArea: HTMLTextAreaElement) {
    textArea.rows = 1;

    const height = textArea.scrollHeight;
    textArea.rows = Math.floor(height / 26); // 20px = line-height: 1.25rem
    if (this.registry && this.registry.introductionText !== textArea.value) {
      this.hitchdForm.markAsTouched();
    }
  }

  load() {

    if (this.registry) {

      this.hitchdForm.controls['country'].setValue(this.registry.country);
      this.hitchdForm.controls['profileImageUrl'].setValue(
        this.registry.profileImageUrl
      );

      if (!this.registry.hideIntroText) {
        this.registry.hideIntroText = false;
      }

      if(this.user && this.user.partnerEmail){
        this.hitchdForm.controls['partnerEmail'].setValue(       this.user.partnerEmail)
      }
      


      this.hitchdForm.controls['hideIntroTitle'].setValue(this.registry.hideIntroTitle);
      this.hitchdForm.controls['hideRecommendedAmount'].setValue(this.registry.hideRecommendedAmount);
      this.hitchdForm.controls['showRecommendedAmount'].setValue(this.registry.showRecommendedAmount);
      this.hideRecommendedAmount = this.registry.hideRecommendedAmount;
      this.showRecommendedAmount = this.registry.showRecommendedAmount;
      this.hitchdForm.controls['hasPassword'].setValue(this.registry.hasPassword);
      this.hitchdForm.controls['password'].setValue(this.registry.password);

      this.hitchdForm.controls['hideHashtag'].setValue(this.registry.hideHashtag);
      this.hitchdForm.controls['hashtag'].setValue(this.registry.hashtag);

      this.hitchdForm.controls['hideIntroText'].setValue(this.registry.hideIntroText);

      this.hitchdForm.controls['firstName'].setValue(this.registry.firstName);
      this.hitchdForm.controls['partnerFirstName'].setValue(
        this.registry.partnerFirstName
      );
      this.registryName = this.registry.registryName.toLowerCase();
      this.hitchdForm.controls['weddingDay'].setValue(this.registry.weddingDay);
      this.hitchdForm.controls['weddingMonth'].setValue(
        this.registry.weddingMonth
      );
      this.hitchdForm.controls['weddingYear'].setValue(
        this.registry.weddingYear
      );
      this.hitchdForm.controls['registryName'].setValue(
        this.registry.registryName.toLowerCase()
      );
      this.hitchdForm.controls['introductionText'].setValue(
        this.registry.introductionText
      );

      this.hitchdForm.controls['introTitle'].setValue(
        this.registry.introTitle
      );

   
      this.hitchdForm.controls['currency'].setValue(this.registry.currency);
      this.updateCurrency();

      if (
        this.registry.weddingDay &&
        this.registry.weddingMonth &&
        this.registry.weddingYear
      ) {
        this.date = new Date(
          this.registry.weddingYear,
          this.registry.weddingMonth - 1,
          this.registry.weddingDay
        );
        this.regOriginalDate = this.date;
      }
      // this.hitchdForm.controls['middleName'].setValue(this.registry.middleName); - (ノಠ益ಠ)ノ彡┻━┻

      if (this.date) {
        this.hitchdForm.controls['weddingDay'].setValue(this.date.getDate());
        this.hitchdForm.controls['weddingMonth'].setValue(
          this.date.getMonth() + 1
        );
        this.hitchdForm.controls['weddingYear'].setValue(
          this.date.getFullYear()
        );
      }


      let defaultGiftAmount;

      if (this.registry.defaultGiftPrice && this.registry.showRecommendedAmount) {
        defaultGiftAmount = this.registry.defaultGiftPrice;
        this.hitchdForm.controls['defaultGiftPrice'].setValue(defaultGiftAmount);
      } else {
        this.registry.defaultGiftPrice = null;
      }



      this.ngAfterViewInit();

      // this.hitchdForm.markAsDirty();
      for (const field in this.hitchdForm.controls) {
        // 'field' is a string

        if (this.hitchdForm.controls.hasOwnProperty(field)) {
          const control = this.hitchdForm.get(field); // 'control' is a FormControl
          if (control.value) {
            control.markAsDirty();
          }
        }
      }

      if (
        this.registry.weddingDay &&
        this.registry.weddingMonth &&
        this.registry.weddingYear
      ) {
        this.noDate = false;
      } else {
        this.noDate = true;
      }

      this._route.data.takeUntil(this.ngUnsubscribe).subscribe(data => {
        const focus = data['focus'] as boolean;
        if (focus) {
          const introtext = document.getElementById('introtext');
          if (introtext) {
            introtext.focus();
          }
        }
      });
    }
  }

  markFormAsTouched() {
    for (const key in this.hitchdForm.controls) {
      if (this.hitchdForm.controls.hasOwnProperty(key)) {
        const control: FormControl = <FormControl>this.hitchdForm.controls[key];
        {
          control.markAsTouched();
        }
      }
    }
  }

  setIsWeddingRegistry(isWeddingReg: boolean) {
    
    this.registry.isWeddingRegistry = isWeddingReg;
    this.hitchdForm.controls['isWeddingRegistry'].setValue(this.registry.isWeddingRegistry);
    this.hitchdForm.markAsTouched();
  }

  setIsOtherRegistry(isOtherRegistry:boolean){
  
    this.registry.isOtherRegistry = isOtherRegistry;
    this.hitchdForm.controls['isOtherRegistry'].setValue(this.registry.isOtherRegistry);
    this.hitchdForm.markAsTouched();
  }

  save() {
    if (
      this.hitchdForm.controls['introductionText'] &&
      this.hitchdForm.controls['introductionText'].touched
    ) {
      this._analyticsService.update({ registryDescriptionUpdate: true });
    }

    if (
      this.hitchdForm.controls['firstName'].touched &&
      this.hitchdForm.controls['firstName'].value
    ) {
      this._analyticsService.update({
        name: this.hitchdForm.controls['firstName'].value
      });
    }

    if (!this.noDate && this.date) {
      this.hitchdForm.controls['weddingDay'].setValue(this.date.getDate());
      this.hitchdForm.controls['weddingMonth'].setValue(
        this.date.getMonth() + 1
      );
      this.hitchdForm.controls['weddingYear'].setValue(this.date.getFullYear());

      this._analyticsService.update({ weddingDate: this.date });
    }
    this.procesing = true;
    this.markFormAsTouched();
    if (this.hitchdForm.valid) {


      const formValue = JSON.stringify(this.hitchdForm.value);

      if(this.hitchdForm.controls['partnerEmail'].value){
        this.user.partnerEmail = this.hitchdForm.controls['partnerEmail'].value;
        this._registryFirebaseService.updateUser(this.user)
        
      }
      

      this._registryFirebaseService
        .updateRegistry(formValue, this.user, this.registry)
        .then(x => {

        

          const RegistryName = this.hitchdForm.controls['registryName'].value;
          this.saved.emit(RegistryName);
          this.setTitle();


          this._registryService.sendFbTrackEvent('Updated personal details');

          this._analyticsService.update({
            registryUrl: 'https://www.hitchd.com/' + this.registryName
          });
          this.hitchdForm.markAsUntouched();

         

          setTimeout(() => {
            this.procesing = false;
          }, 1 * 1000);
        });
    }
  }

  populateDateDropDownValues() {
    this.days = new Array();
    for (let i = 1; i < 32; i++) {
      this.days.push(i);
    }

    this.years = new Array();
    for (let i = 2017; i < 2025; i++) {
      this.years.push(i);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/personal/personal.component.ts